import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaRunning, FaRecycle, FaMicroscope } from 'react-icons/fa';


const Info = () => {
  const { t } = useTranslation();
  const features = t('home.info.features', { returnObjects: true });

  // Mapping of icon names to actual icon components
  const iconMap = {
    running: <FaRunning className="text-6xl mb-4 text-secondColor" />,
    recycle: <FaRecycle className="text-6xl mb-4 text-secondColor" />,
    microscope: <FaMicroscope className="text-6xl mb-4 text-secondColor" />
  };

  return (
    <section className="bg-gradient-to-b from-white to-gray-50 py-12 md:py-16 px-4 md:px-6">
      <div className="container mx-auto max-w-7xl">
        <header className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primeColor mb-4 relative inline-block">
            {t('home.info.title') || 'Why Choose Us'}
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-secondColor mt-2"></span>
          </h2>
        </header>
        
        {/* Grid layout for the features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="group flex flex-col items-center p-6 md:p-8 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="mb-4 transform group-hover:scale-110 transition-transform duration-300">
                {iconMap[feature.icon]}
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 text-primeColor group-hover:text-secondColor transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Info;
